import { useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";

const EmailNotifications = () => {
    const intl = useIntl();

    const SeeMoreLink = `https://www.atlassian.com${useLocalizedHref(
        "/licensing/cloud#whats-the-difference-between-free-standard-and-premium"
    )}`;

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.EmailNotifications.header",
            defaultMessage: "Email notifications"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.EmailNotifications.body",
            defaultMessage:
                "The type of notifications that someone receives depends on their role and how they’ve interacted with the request. Customers, agents, and administrators get email notifications about activity on requests."
        }),
        body2: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.EmailNotifications.body2",
                defaultMessage:
                    "Our Free plan for Jira Service Management lets you send a maximum of 100 emails each day. After 100 emails, your notifications will be paused until the following day. See more about <seeMore>email notification limits for our Free plan.</seeMore>"
            },
            {
                seeMore: (chunk: React.ReactNode) => (
                    <a
                        href={SeeMoreLink}
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="jiraServiceManagement"
                        data-label-english="Learn more"
                    >
                        {chunk}
                    </a>
                )
            }
        ),
        link: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.EmailNotifications.link",
                defaultMessage:
                    "<learnMore>Learn more</learnMore> about which notifications your customers and team will receive."
            },
            {
                learnMore: (chunk: React.ReactNode) => (
                    <a
                        href="https://support.atlassian.com/jira-service-management-cloud/docs/what-notifications-do-my-customers-and-service-desk-team-receive/"
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="jiraServiceManagement"
                        data-label-english="Learn more"
                    >
                        {chunk}
                    </a>
                )
            }
        )
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
            <p>{messages.body2}</p>
            <p>{messages.link}</p>
        </>
    );
};

export default EmailNotifications;
